import React, { useState, useEffect, useRef } from 'react'
import Select from 'react-select'
import { CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CFormTextarea, CFormLabel, CButton, CNav, CNavItem, CNavLink, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormInput } from '@coreui/react'
import classNames from 'classnames'
import LabCRUD from '../../services/general/LabsAPI.api.js'
import MedicineCRUD from '../../services/general/Medication.api'
import ImagingInformation from '../../services/general/ImagingAPI.api.js'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import SuggestionDiagnosis from './SuggestionDiagnosis.jsx'
import PlanSuggestions from './PlanSuggestions.jsx'
import CheckOptionSelections from '../../components/shared/CheckOptionSelections'
import GenricAccordian from '../../components/shared/GenricAccordian.jsx'

const AccordianPlanSuggestion = ({ suggestions, parentId, onSuggestionsChange, orders, setSaveResoanChange, selectedDiagnosis, handlePlanSuggestionsChange, planSuggestions, setParentAccordions, information, handleAddStatementDescription, setActiveDescriptions }) => {
  const [expanded, setExpanded] = useState(null)
  const [selectedData, setSelectedData] = useState({})
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [labList, setLabList] = useState([])
  const [medicationList, setMedicationList] = useState([])
  const [imagingList, setImagingList] = useState([])
  const [labOptions, setLabOptions] = useState([])
  const [medicationOptions, setMedicationOptions] = useState([])
  const [imagingOptions, setImagingOptions] = useState([])
  const [activeKey, setActiveKey] = useState(null)
  const [activeTab, setActiveTab] = useState('order')
  const [suggestionsData, setSuggestionsData] = useState([])

  // useEffect(() => {

  //     const initialData = {};
  //     orders?.forEach((order) => {
  //         const suggestionName = order?.name;
  //         initialData[suggestionName] = {
  //             Lab: order?.data?.Lab || [],
  //             Medication: order?.data?.Medication || [],
  //             Imaging: order?.data?.Imaging || [],
  //         };
  //     });
  //     setSelectedData(initialData);

  // }, [orders]);
  // useEffect(() => {
  //     setSuggestionsData(planSuggestions || [])
  // }, [planSuggestions]);

  useEffect(() => {
    setActiveTab('order')
  }, [selectedDiagnosis])

  const debounceTimeout = useRef(null)
  const debounce = (func, delay) => {
    clearTimeout(debounceTimeout.current)
    debounceTimeout.current = setTimeout(func, delay)
  }

  const triggerSaveSuggestions = (updatedData) => {
    const formattedSuggestions = suggestions.map((suggestion) => ({
      name: suggestion,
      data: updatedData[suggestion] || {},
    }))
    setSaveResoanChange({ formattedSuggestions, parentId })
    debounce(() => {
      onSuggestionsChange(formattedSuggestions, parentId)
    }, 300)
  }

  const handleMultiSelectChange = (suggestionName, type, selectedOptions) => {
    setSelectedData((prev) => {
      const updatedData = {
        ...prev,
        [suggestionName]: {
          ...prev[suggestionName],
          [type]: selectedOptions.map((option) => ({
            value: option,
            reason: prev[suggestionName]?.[type]?.find((item) => item.value.value === option.value)?.reason || '',
          })),
        },
      }
      triggerSaveSuggestions(updatedData)
      return updatedData
    })
  }

  const handleReasonChange = (suggestionName, type, value, index) => {
    setSelectedData((prev) => {
      const updatedData = {
        ...prev,
        [suggestionName]: {
          ...prev[suggestionName],
          [type]: prev[suggestionName][type].map((item, idx) => (idx === index ? { ...item, reason: value } : item)),
        },
      }
      triggerSaveSuggestions(updatedData)
      return updatedData
    })
  }

  const handleSaveSuggestions = () => {
    try {
      const formattedSuggestions = suggestions.map((suggestion) => ({
        name: suggestion,
        data: selectedData[suggestion] || {},
      }))
      onSuggestionsChange(formattedSuggestions, parentId)
      toast.success('Successfully Order Added', toastConfig)
    } catch (err) {
      console.log(err, 'error on order save')
    }
  }

  const getLabData = async () => {
    setIsPageLoading(true)
    try {
      let labData = await LabCRUD('GETALL', '{}')
      labData = JSON.parse(labData.d)?.Data
      setLabList(labData)

      if (labData.length > 0) {
        let option = labData?.map((item) => ({
          value: item.ID,
          label: item.LabName,
        }))
        setLabOptions(option)
      }
      setIsPageLoading(false)
    } catch (error) {
      setIsPageLoading(false)
    }
  }

  const getMedicationData = async () => {
    setIsPageLoading(true)
    try {
      let allMedicines = await MedicineCRUD('GET')

      let formattedData
      formattedData = JSON.parse(allMedicines.d)?.Data
      formattedData = formattedData.map((item) => {
        return {
          ...item,
          Data: JSON.parse(item.Data),
        }
      })
      if (formattedData) {
        let medicationData = formattedData.map((item) => item.Data)
        setMedicationList(medicationData)

        if (medicationData.length > 0) {
          let option = medicationData?.map((item) => ({
            value: item.id,
            label: item.name,
          }))
          setMedicationOptions(option)
        }
      }
      setIsPageLoading(false)
    } catch (e) {
      console.error('Error fetching medication data', error)
      setIsPageLoading(false)
    }
  }

  const getImagingData = async () => {
    setIsPageLoading(true)
    try {
      const data = await ImagingInformation('GET_ALL')
      if (data) {
        const formattedData = JSON.parse(data.d)?.Data
        setImagingList(formattedData)
        if (formattedData.length > 0) {
          let option = formattedData?.map((item) => ({
            value: item.ID,
            label: item.Name,
          }))
          setImagingOptions(option)
        }
      }
    } catch (error) {
      console.error('Error fetching imaging data', error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const handleSavePlanSuggestions = () => {
    try {
      handlePlanSuggestionsChange(suggestionsData, parentId)
      // toast.success('Successfully Plan Suggestions Added', toastConfig)
    } catch (err) {
      console.log(err, 'error on Plan Suggestion save')
    }
  }

  const handleAccordionsUpdate = (suggestionName, updatedAccordions) => {
    setSuggestionsData((prevData) => {
      const existingIndex = prevData?.findIndex((item) => item.name === suggestionName)
      if (existingIndex !== -1) {
        const updatedData = [...prevData]
        updatedData[existingIndex] = {
          ...updatedData[existingIndex],
          accordions: updatedAccordions,
        }
        return updatedData
      } else {
        return [
          ...prevData,
          {
            name: suggestionName,
            accordions: updatedAccordions,
          },
        ]
      }
    })

    // debounce(() => {
    //     handleSavePlanSuggestions();
    // }, 300);
  }
  // useEffect(() => {
  //     handleSavePlanSuggestions();
  // }, [suggestionsData])

  useEffect(() => {
    if (suggestionsData.length > 0) {
      debounce(() => {
        handleSavePlanSuggestions(suggestionsData)
      }, 300)
    }
  }, [suggestionsData])

  useEffect(() => {
    getLabData()
    getMedicationData()
    getImagingData()
  }, [])

  return (
    <div>
      {suggestions?.map((suggestion, index) => {
        return (
          <div>
            <GenricAccordian
              title={suggestion}
              index={index}
              setParentAccordions={setParentAccordions}
              parentId={parentId}
              information={information}
              handleAddStatementDescription={handleAddStatementDescription}
              setActiveDescriptions={setActiveDescriptions}
              //  content={<div>
              //     <div>
              //         <CNav variant="pills" role="tablist" className="justify-content-center">
              //             <CNavItem>
              //                 <CNavLink
              //                     active={activeTab === 'order'}
              //                     onClick={() => setActiveTab('order')}
              //                 >
              //                     Order
              //                 </CNavLink>
              //             </CNavItem>
              //             <CNavItem>
              //                 <CNavLink
              //                     active={activeTab === 'plan'}
              //                     onClick={() => setActiveTab('plan')}
              //                 >
              //                     Plan Suggestion
              //                 </CNavLink>
              //             </CNavItem>

              //         </CNav>
              //     </div>
              //     {activeTab === 'order' && <>
              //         <div className="mt-2">
              //             <CheckOptionSelections
              //                 options={labOptions}
              //                 selectedValue={selectedData[suggestion]?.Lab?.map((item) => item.value) || []}
              //                 setSelectedValue={(selectedOptions) => handleMultiSelectChange(suggestion, "Lab", selectedOptions)}
              //                 Label={'Lab'}
              //             />
              //             {selectedData[suggestion]?.Lab?.map((lab, idx) => (
              //                 <div className="m-2" key={lab.value.value}>
              //                     <CFormTextarea
              //                         placeholder={`Reason for ${lab.value.label}`}
              //                         value={lab.reason || ""}
              //                         onChange={(e) => handleReasonChange(suggestion, "Lab", e.target.value, idx)}
              //                     />
              //                 </div>
              //             ))}
              //         </div>
              //         <div>
              //             <CheckOptionSelections
              //                 options={medicationOptions}
              //                 selectedValue={selectedData[suggestion]?.Medication?.map((item) => item.value) || []}
              //                 setSelectedValue={(selectedOptions) => handleMultiSelectChange(suggestion, "Medication", selectedOptions)}
              //                 Label={'Medication'}
              //             />
              //             {selectedData[suggestion]?.Medication?.map((medication, idx) => (
              //                 <div className="m-2" key={medication.value.value}>
              //                     <CFormTextarea
              //                         placeholder={`Reason for ${medication.value.label}`}
              //                         value={medication.reason || ""}
              //                         onChange={(e) => handleReasonChange(suggestion, "Medication", e.target.value, idx)}
              //                     />
              //                 </div>
              //             ))}
              //         </div>
              //         <div>
              //             <CheckOptionSelections
              //                 options={imagingOptions}
              //                 selectedValue={selectedData[suggestion]?.Imaging?.map((item) => item.value) || []}
              //                 setSelectedValue={(selectedOptions) => handleMultiSelectChange(suggestion, "Imaging", selectedOptions)}
              //                 Label={'Imaging'}
              //             />

              //             {selectedData[suggestion]?.Imaging?.map((imaging, idx) => (
              //                 <div className="m-2" key={imaging.value.value}>
              //                     <CFormTextarea
              //                         placeholder={`Reason for ${imaging.value.label}`}
              //                         value={imaging.reason || ""}
              //                         onChange={(e) => handleReasonChange(suggestion, "Imaging", e.target.value, idx)}
              //                     />
              //                 </div>
              //             ))}
              //         </div>

              //     </>}
              //     {activeTab === 'plan' && (
              //         <div className="mt-3">
              //             <PlanSuggestions
              //                 key={index}
              //                 parentSuggestionId={parentId}
              //                 suggestionName={suggestion}
              //                 selectedDiagnosis={selectedDiagnosis}
              //                 onAccordionsUpdate={handleAccordionsUpdate}
              //                 planAccordions={suggestionsData && suggestionsData[index] || []}
              //             />
              //         </div>
              //     )}

              // </div>}
            />
          </div>
        )
      })}
    </div>
  )
}

export default AccordianPlanSuggestion
